module.exports = __webpack_public_path__ + "static/media/xero.91dc2f31.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/xero.png
// module id = 1392
// module chunks = 0